__turbopack_context__.v({
  "actionLink": "QualityScore-module__3B8Ida__actionLink",
  "container": "QualityScore-module__3B8Ida__container",
  "header": "QualityScore-module__3B8Ida__header",
  "progressForeground": "QualityScore-module__3B8Ida__progressForeground",
  "scoreContainer": "QualityScore-module__3B8Ida__scoreContainer",
  "scoreGood": "QualityScore-module__3B8Ida__scoreGood",
  "scoreGreat": "QualityScore-module__3B8Ida__scoreGreat",
  "scoreInfo": "QualityScore-module__3B8Ida__scoreInfo",
  "scoreLabel": "QualityScore-module__3B8Ida__scoreLabel",
  "scoreOkay": "QualityScore-module__3B8Ida__scoreOkay",
  "scorePoor": "QualityScore-module__3B8Ida__scorePoor",
  "scoreValue": "QualityScore-module__3B8Ida__scoreValue",
});
